import { env } from '@/services/dev';
import utils from '@/services/tools';
import http from '@/services/http';

export default {
  getUserBehaviorList(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/user_behavior_brief_query`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
};
